import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Colleges from "../indianCollege/IndianCollege";
import CollegeRequests from "./CollegeRequests";

const CollegeTabs = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Get tab from URL query parameters or default to "indian-colleges"
  const getInitialTab = () => {
    const searchParams = new URLSearchParams(location.search);
    const tabParam = searchParams.get("tab");
    return tabParam || "indian-colleges";
  };

  const [activeTab, setActiveTab] = useState(getInitialTab);

  const tabs = [
    {
      id: "indian-colleges",
      label: "INDIAN COLLEGES",
      component: <Colleges />,
    },
    {
      id: "college-requests",
      label: "COLLEGE REQUESTS",
      component: <CollegeRequests />,
    },
  ];

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    navigate(`?tab=${tabId}`);
  };

  // Update active tab when URL changes
  useEffect(() => {
    setActiveTab(getInitialTab());
  }, [location.search]);

  return (
    <div className="ct-college-tabs-container">
      <div className="ct-integrated-tab-header">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`ct-integrated-tab ${
              activeTab === tab.id ? "ct-active" : ""
            }`}
            onClick={() => handleTabClick(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="ct-tab-content">
        {tabs.find((tab) => tab.id === activeTab)?.component}
      </div>
    </div>
  );
};

export default CollegeTabs;
